import React from 'react';
import classNames from 'classnames';
import styles from './css/index.module.scss';
import ArrowRightIcon from '../../../../assets/icons/bigArrowRight.svg';
import ArrowDownIcon from '../../../../assets/icons/bigArrowDown.svg';
import useTranslations from '../../../../hooks/useTranslations';
import { DICTIONARY } from '../../../../translations/dictionary';

function SidebarHint({ isCompositionSet, isMobile }) {
  const { t } = useTranslations();

  const title = isCompositionSet
    ? t(DICTIONARY.soundproofingPage.paramsSetTitle)
    : t(DICTIONARY.soundproofingPage.selectComponentTitle);

  const text = isCompositionSet
    ? t(DICTIONARY.soundproofingPage.paramsSetText)
    : isMobile
      ? t(DICTIONARY.soundproofingPage.selectComponentTextMobile)
      : t(DICTIONARY.soundproofingPage.selectComponentText);

  return (
    <div className={classNames(styles.hint, { [styles.hintMobile]: isMobile })}>
      <p className={styles.title}>{title}</p>
      <p className={styles.text}>{text}</p>

      {!isMobile && (
        <img
          src={isCompositionSet ? ArrowDownIcon : ArrowRightIcon}
          alt=""
          className={isCompositionSet ? styles.arrowDown : styles.arrowRight}
        />
      )}
    </div>
  );
}

export default SidebarHint;
